<h3 *ngIf="data.title" mat-dialog-title>{{data.title}}</h3>
<div mat-dialog-content>
  <p *ngIf="data.message" [innerHTML]="data.message"></p>
  <label>Time Remaining: </label> {{countdown$ | async | minutesSeconds}}
</div>
<div mat-dialog-actions>
  <button mat-raised-button (click)="onClick('no')">{{data.noButtonLabel}}</button>
  <button mat-raised-button [mat-dialog-close]="true" (click)="onClick('yes')" cdkFocusInitial>{{data.yesButtonLabel}}</button>
</div>
